import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our Next-Gen Blockchain App Developemnt Services to{" "}
              <span>Revolutionize Your Business</span>
            </h2>
            <p>
              Get blockchain development done right with our team’s professional
              skillset. We have dedicated experienced employees capable of
              developing unique, state-of-the-art solutions for various industry
              clients to produce high-performance and highly secure blockchain
              applications.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult Blockchain Solutions
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Blockchain Consulting and Strategy</h4>
                  <p>
                    From indie project conception to advanced solution planning,
                    our blockchain consulting and strategy help. We study your
                    business requirements, build specific blockchain solutions,
                    and develop relevant planning scenarios. Take advantage of
                    our extensive experience to unlock the potential of
                    blockchain technology and fulfill your dream.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>dApps Development</h4>
                  <p>
                    Maximize the potential of decentralized applications with
                    our reliable dApp solutions. Our focus is on developing
                    efficient and secure decentralized applications suitable for
                    multiple blockchain frameworks. Our team guarantees your
                    dApp is as optimal as possible, both functionally and to its
                    rivals in the decentralized universe.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CryptoCurrency Wallet and Exchange</h4>
                  <p>
                    Cryptocurrency wallet and exchange development is safe, easy
                    to use, and robust in functionality, we offer it for
                    startups and large companies. Our wallets provide secure
                    storage solutions for multiple assets with extra layered
                    security, as well as efficient exchanges enabling fast and
                    secure trading in the cryptocurrencies.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Layer-2 Development</h4>
                  <p>
                    Improve the scalability and speed of your blockchain
                    solutions using our Layer-2 development services from us.
                    With Layer-2 protocols, we eliminate the problem of higher
                    transaction fees and low throughput for your blockchain
                    applications respecting decentralization and security.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Smart Contract Audit & Development</h4>
                  <p>
                    Our smart contracts’ audit and development solutions keep
                    your contracts protected and perform efficiently. With
                    meticulous detail, we develop, debug, and deploy smart
                    contracts aligned with best practices and robust security
                    protocols. Our audit solutions help highlight risks and
                    their possible solutions, making your contracts work
                    precisely.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Asset Tokenization Platform Development</h4>
                  <p>
                    Our asset tokenization platform development services allow
                    you to convert tangible and intangible assets into tokens.
                    We design highly secure and scalable platforms that
                    efficiently tokenize real estate, commoditized, and
                    intangible assets for faster ownership transfer, improved
                    liquidity, and broader access.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Cryptocurrency Exchange Development</h4>
                  <p>
                    The provided cryptocurrency exchange development solutions
                    offer demanded secure platforms for trading
                    cryptocurrencies. Our services include smart trading united
                    intelligent engines, multi-layer security, and transparent
                    simple user interfaces that will smooth your users’ trading.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>ICO Development</h4>
                  <p>
                    Start your ICO with us now using our all-in-one ICO
                    development solutions and feel free from any uncertainties.
                    Our services range from white paper drafting and smart
                    contract coding to marketing and legal advice, and we offer
                    everything required to launch an effective ICO and attract
                    investors and funds.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Solidity Development</h4>
                  <p>
                    Empower your business with Ethereum through our professional
                    services in Solidity. Our deliverables are smart contracts
                    that are secure and efficient in Solidity, which is
                    Ethereum's most widely used language. They guarantee your
                    smart contracts are coded efficiently for speed and
                    scrutinize your contracts to remove vulnerabilities.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
